import { useQuery, useQueryClient } from "react-query";
import { organizationApiRequest } from "./client";
import { getAuthenticatedUser } from "../auth-api-client";
const FALLBACK_SCHOOL_TIMEZONE = "America/Los_Angeles";
function fetchOrganization(districtId, schoolId) {
  return organizationApiRequest({
    url: `/organization/district/${districtId}/school/${schoolId}`
  }).catch(() => ({}));
}
function fetchOrgSchool(schoolId) {
  return organizationApiRequest({
    url: `/organization/school/${schoolId}`
  }).catch(() => ({}));
}
function useOrganizationQuery(districtId, schoolId) {
  return useQuery(
    ["schoolGradeMetrics", schoolId],
    () => fetchOrganization(districtId, schoolId),
    {
      enabled: !!districtId && !!schoolId
    }
  );
}
const useSchoolOrgQuery = () => {
  const schoolId = getAuthenticatedUser().school_id;
  return useQuery(["school"], () => fetchOrgSchool(schoolId), {
    staleTime: Infinity,
    cacheTime: Infinity
  });
};
const useSchoolTimezoneQuery = () => {
  var _a, _b;
  const queryClient = useQueryClient();
  const school = queryClient.getQueryData(["school"]);
  return (_b = (_a = school == null ? void 0 : school.schoolTimezone) == null ? void 0 : _a.timezone) != null ? _b : FALLBACK_SCHOOL_TIMEZONE;
};
export {
  useOrganizationQuery,
  useSchoolOrgQuery,
  useSchoolTimezoneQuery
};
